import { API_URL, EASYSIGN_SERVICE_PATH } from '@constants/apiUrl'
import { axiosInstance } from '@methods/axiosConfig'
import { getUrlParam } from '@methods/urlParams'

export const getErrorRedirectUrl = () => {
  const language = getUrlParam('language') || 'en'
  const themeId = getUrlParam('themeId') || 'signicatTheme'

  return `${window.location.origin}/error-otp-verification-failed?language=${encodeURIComponent(
    language
  )}&themeId=${encodeURIComponent(themeId)}`
}

export const postSendOtp = async (phoneNumber: string) => {
  const res = await axiosInstance.post<{ otpValidUntilUnixTimeSeconds?: number }>(
    `${API_URL}/${EASYSIGN_SERVICE_PATH}/sms-otp/send`,
    {
      phoneNumber,
    },
    {
      withCredentials: true,
    }
  )

  return res
}
